import AppHeader from "@/components/AppHeader";
import AppLoading from "@/components/AppLoading";
import dayjs from "dayjs";

export default {
  name: "attendace",
  components: {
    AppHeader,
    AppLoading,
  },
  async created() {
    if (window.sessionStorage.getItem("attendance_search")) {
      const data = JSON.parse(
        window.sessionStorage.getItem("attendance_search")
      );
      this.selectedCompany = data.companyId;
    }
    this.getCompany();
    if (window.sessionStorage.getItem("attendance_search")) {
      const data = JSON.parse(
        window.sessionStorage.getItem("attendance_search")
      );
      this.selectedDepartment = data.departmentId;
    }
    this.getDepartment();
    await this.getTargetDate();
    if (window.sessionStorage.getItem("attendance_search")) {
      const data = JSON.parse(
        window.sessionStorage.getItem("attendance_search")
      );
      this.selectedMonth = data.selectedMonth;
    }
    this.search();
  },
  data() {
    return {
      companies: "",
      departments: [],
      users: [],
      selectedCompany: localStorage.company_id,
      selectedDepartment: "",
      selectedMonth: "",
      targetDates: [],
      getCompanisEnd: false,
      getDepartmentsEnd: false,
      searchEnd: false,
      attendances: [],
      savingFlag: false,
      file: null,
      errorInfo: "",
      successInfo: "",
    };
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name === "attendance" ||
      to.name === "attendance_user_detail" ||
      to.name === "attendance_date_detail"
    ) {
      const savedata = {
        companyId: this.selectedCompany,
        departmentId: this.selectedDepartment,
        selectedMonth: this.selectedMonth,
      };
      window.sessionStorage.setItem(
        "attendance_search",
        JSON.stringify(savedata)
      );
    } else {
      window.sessionStorage.removeItem("attendance_search");
    }
    next();
  },
  computed: {
    authorityCheckCanUseCompany() {
      if (localStorage.user_authority == 1) {
        // 総務部でログイン
        return true;
      }
      return false;
    },
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch((err) => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompanisEnd = true;
    },
    async getDepartment() {
      this.getDepartmentsEnd = false;
      let data = {
        company_id: this.selectedCompany,
      };
      let res = await this.$store
        .dispatch("GET_DEPARTMENT", { data: data })
        .catch((err) => {
          console.log(err);
          return;
        });
      this.departments = res.departments;
      this.getDepartmentsEnd = true;
    },
    getTargetDate() {
      if (this.selectedCompany == 1) {
        let targetYyyyMm = dayjs("2020-04").format("YYYY-MM");
        let endYyyyMm = dayjs().format("YYYY-MM");
        for (;;) {
          if (targetYyyyMm > endYyyyMm) break;
          this.targetDates.unshift({
            text: dayjs(targetYyyyMm).format("YYYY年MM月"),
            value: dayjs(targetYyyyMm).format("YYYY-MM"),
          });
          this.selectedMonth = dayjs(targetYyyyMm).format("YYYY-MM");
          targetYyyyMm = dayjs(targetYyyyMm)
            .add(1, "month")
            .format("YYYY-MM");
        }
      } else {
        let today = new Date();
        let targetYyyyMm = dayjs("2020-04").format("YYYY-MM");
        let endYyyyMm = dayjs().format("YYYY-MM");
        if (today.getDate() >= 16) {
          endYyyyMm = dayjs()
            .add(1, "month")
            .format("YYYY-MM");
        }
        this.targetDates = [];
        for (;;) {
          if (targetYyyyMm > endYyyyMm) break;
          this.targetDates.unshift({
            text: dayjs(targetYyyyMm).format("YYYY年MM月"),
            value: dayjs(targetYyyyMm).format("YYYY-MM"),
          });
          this.selectedMonth = dayjs(targetYyyyMm).format("YYYY-MM");
          targetYyyyMm = dayjs(targetYyyyMm)
            .add(1, "month")
            .format("YYYY-MM");
        }
      }
    },
    async search() {
      this.searchEnd = false;
      let data = {
        company_id: this.selectedCompany,
        department_id: this.selectedDepartment,
        target_month: this.selectedMonth,
      };
      let res = await this.$store
        .dispatch("GET_ATTENDANCE_LIST", { data: data })
        .catch((err) => {
          console.log(err);
          return;
        });
      this.attendances = res.attendances;
      this.searchEnd = true;
    },
    changeCompany() {
      this.selectedDepartment = "";
      this.targetDates = [];
      this.selectedMonth = "";
      this.getDepartment();
      this.getTargetDate();
    },
    goAttendanceUserDetail(userId) {
      this.$router.push({ path: `/attendance/${userId}/user` });
    },
    async outputDailyReportPdf() {
      let data = {
        company_id: this.selectedCompany,
        department_id: this.selectedDepartment,
        selected_month: this.selectedMonth,
      };
      let res = await this.$store
        .dispatch("PDF_DAILY_REPORT", { data: data })
        .catch((err) => {
          console.log(err);
          return;
        });
      let link = document.createElement("a");
      let pdfFileName = "作業日報" + this.selectedMonth + ".pdf";
      let bom = new Uint8Array([0xef, 0xbb, 0xbf]);

      const blob = new Blob([bom, res], { type: "application/pdf" });

      link.style = "display: none";
      link.download = pdfFileName;
      link.target = "_blank";

      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, pdfFileName);
      } else if (window.URL && window.URL.createObjectURL) {
        link.href = window.URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else if (window.webkitURL && window.webkitURL.createObject) {
        link.href = (window.URL || window.webkitURL).createObjectURL(blob);
        link.click();
      }
    },
    selectedCsv(event) {
      if (event) {
        event.preventDefault();
        let files = event.target.files;
        this.file = files[0];
      }
    },
    async paidLeaveUpload() {
      if (this.savingFlag) return;
      this.savingFlag = true;
      this.errorInfo = "";
      this.successInfo = "";
      this.uploadEnd = false;
      let form = new FormData();
      form.append("file", this.file);

      let res = await this.$store
        .dispatch("IMPORT_CSV_PAID_LEAVE", { data: form })
        .catch((err) => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.successInfo = "CSVアップロードが正常終了しました。";
      }
      this.uploadEnd = true;
      this.search();
      this.savingFlag = false;
    },
  },
};
